/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiJMESPathExpressionTestRequest,
    InternalApiJMESPathExpressionTestRequestFromJSON,
    InternalApiJMESPathExpressionTestRequestToJSON,
    InternalApiJMESPathExpressionTestResult,
    InternalApiJMESPathExpressionTestResultFromJSON,
    InternalApiJMESPathExpressionTestResultToJSON,
} from '../models';

export interface TestExpressionRequest {
    internalApiJMESPathExpressionTestRequest: InternalApiJMESPathExpressionTestRequest;
}

/**
 * 
 */
export class JMESPathExpressionTestApi extends runtime.BaseAPI {

    /**
     */
    async testExpressionRaw(requestParameters: TestExpressionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiJMESPathExpressionTestResult>> {
        if (requestParameters.internalApiJMESPathExpressionTestRequest === null || requestParameters.internalApiJMESPathExpressionTestRequest === undefined) {
            throw new runtime.RequiredError('internalApiJMESPathExpressionTestRequest','Required parameter requestParameters.internalApiJMESPathExpressionTestRequest was null or undefined when calling testExpression.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/jmespath/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiJMESPathExpressionTestRequestToJSON(requestParameters.internalApiJMESPathExpressionTestRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiJMESPathExpressionTestResultFromJSON(jsonValue));
    }

    /**
     */
    async testExpression(requestParameters: TestExpressionRequest, initOverrides?: RequestInit): Promise<InternalApiJMESPathExpressionTestResult> {
        const response = await this.testExpressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
